module.exports = __webpack_public_path__ + "img/pg.8e8092e5.jpg";